import { ErrorBoundary } from '@/shared/ui/ErrorBoundary';
import LeftSection from '../components/LoginLeftSection';
import RightSection from '../components/LoginRightSection';
import { PublicRoute } from '@/app/routes/ProtectedRoute';

function LoginLayout() {
  return (
    <ErrorBoundary>
      <PublicRoute>
        <div className="login-layout">
          <div className="h-screen flex overflow-hidden">
            <LeftSection />
            <RightSection />
          </div>
        </div>
      </PublicRoute>
    </ErrorBoundary>
  );
}

export default LoginLayout;
